'use client'
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import { header, optionsMap } from 'src/views/abi/fields/create-entry-summary';
import SnackBar from 'src/components/era-package/era/SnackBar';
import pathMap from 'src/paths/pathMap';
import RenderFormWithRHF from 'src/components/era-package/forms/RenderFormWithRHF';
import AbiEntrySummaryApiUrls from "../../../../apiUrls/AbiEntrySummaryApiUrls";
import AbiUserSettingsApiUrls from "../../../../apiUrls/AbiUserSettingsApiUrls";
import Spinner from "../../../../components/era-package/era/Spinner";

const CreateEntrySummary = ({ history }) => {
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false)
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [userSetting, setUserSetting] = useState(null)

  const fetchUserSetting = async () => {
    try {
      const response = await fetch(`${AbiUserSettingsApiUrls.GET}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('userToken')),
        },
      });

      if (!response.ok) {
        console.log('Error fetching user setting');
        return {filerCode : ""}
      }

      const json = await response.json();
      return json.data;
    } catch (error) {
      console.log('Error fetching user seting');
      return {filerCode : ""}
    }

  };

  useEffect(() => {
    fetchUserSetting().then(r => setUserSetting(r))
  }, [])


  // Set up form sections including table sections
  const formSections = useMemo(
    () => [
      {
        fields: header,
        headless: true,
        disableGutters: true
      },
    ],
    [],
  );

  // Set up form data
  const allFields = useMemo(
    () => formSections.flatMap((section) => {
      console.log(userSetting?.filerCode)
      section.fields.map(f => f.defaultValue = f.name === 'filerCode' ? userSetting?.filerCode : '')
      return section.fields
    }),
    [formSections, userSetting], // Make sure to update the dependency array
  );

  const handleFormSuccess = async (formData) => {
    console.log(formData)
    try {
      const response = await fetch(AbiEntrySummaryApiUrls.POST, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('userToken'))
        },
        body: JSON.stringify(formData)  // Convert JS object to JSON string
      });

      if (!response.ok) {
        setShowErrorSnackbar(true);
        throw new Error('Failed to submit form');
      }

      const result = await response.json();
      console.log('Form submitted successfully:', result);
      console.log('ABI Trans ID: ', result.data.abiTransId);
      setShowSuccessSnackbar(result.data.abiTransId)
    } catch (error) {
      setShowErrorSnackbar(true);
      console.error('Error submitting form:', error);
    }
  }
  const handleSuccessSnackbarClose = (e, reason) => {
    console.log("abi id: " + showSuccessSnackbar);
    if (reason === 'timeout') {
      history.push(pathMap.ABI_ENTRY_SUMMARY_EDIT_VIEW.replace(':id', showSuccessSnackbar))
      setShowSuccessSnackbar(false)
    }
  }

  // Handle error snackbar close
  const handleErrorSnackbarClose = useCallback(() => {
    setShowErrorSnackbar(false);
  }, []);

  if (!userSetting || userSetting.length === 0) {
    return (
      <div style={{ position: 'relative', height: '200px' }}>    <Spinner />  </div>
    )
  }

  return (<>
    <RenderFormWithRHF
      title="Create Entry Summary"
      formSections={formSections}
      allFields={allFields}
      optionsMap={optionsMap}
      submitLabel="Create"
      onSubmit={handleFormSuccess}
      sx={{ border: 0 }}
      formConfig={{

      }}
    />

    <SnackBar
      title="Form submitted successfully"
      type="success"
      open={!!showSuccessSnackbar}
      onClose={handleSuccessSnackbarClose}
      duration={3000}
    >
      Redirecting to Entry Summary...
    </SnackBar>

    {/* Error Snackbar - Only show when showErrorSnackbar is true */}
    <SnackBar
        title="Form Submittion Error"
        type="error"
        open={showErrorSnackbar}
        onClose={handleErrorSnackbarClose}
        duration={10000}
    >
      Internal error occured, please try again later.
    </SnackBar>
  </>);
};

export default CreateEntrySummary;
